import moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('pt-br');

export const returnDate = (data) => {
  if (!data) return '';

  const now = moment();
  const inputDate = moment(data);

  const diffInHours = now.diff(inputDate, 'hours');
  const diffInDays = now.diff(inputDate, 'days');

  if (diffInDays === 0) {
    if (diffInHours < 1) return moment(data).fromNow(); // ex: "há 5 minutos"
    if (diffInHours < 12) return `${diffInHours} horas atrás`;
    return 'Hoje';
  }

  if (diffInDays === 1) return 'Ontem';

  if (diffInDays < 7) {
    return `${inputDate.format('dddd')} - ${inputDate.format('D [de] MMMM')}`;
  }

  return inputDate.format('DD/MM/yyyy');
};

/**
 * dd/mm/aaaa sem passar por fuso: "aaaa-mm-dd" (LocalDate do backend) é interpretado pelo `new Date`
 * como meia-noite UTC, o que no Brasil (UTC-3) vira o dia anterior. Datas com hora sem fuso
 * ("aaaa-mm-ddTHH:mm:ss", LocalDateTime) também usam só a parte da data. Outros formatos caem no Date.
 */
export function formatarDataSemFuso(valor) {
  if (valor == null || valor === "") return "";
  const partes = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](?!.*(?:Z|[+-]\d{2}:?\d{2})$).*)?$/.exec(String(valor));
  if (partes) return `${partes[3]}/${partes[2]}/${partes[1]}`;
  const data = new Date(valor);
  return isNaN(data) ? String(valor) : data.toLocaleDateString("pt-BR");
}

export function formatLocalDate(localDateStr) {
  if (!localDateStr) return "";
  const [year, month, day] = localDateStr.split("-");
  return `${day}/${month}/${year}`;
}

export function formatLocalDateTime(localDateTimeStr) {
  if (!localDateTimeStr) return "";

  const [datePart, timePart] = localDateTimeStr.split("T");
  if (!datePart || !timePart) return "";

  const [year, month, day] = datePart.split("-");
  const [hour, minute, second] = timePart.split(":");

  if (!year || !month || !day || !hour || !minute || !second) return "";

  return `${day}/${month}/${year} ${hour}:${minute}`;
}

export function getComecoAno() {
  const hoje = new Date();
  const ano = hoje.getFullYear();
  const mes = "01";
  const dia = "01";
  return `${ano}-${mes}-${dia}`;
}

export function getAnoPassado() {
  const hoje = new Date();
  const ano = hoje.getFullYear() - 1;
  const mes = "01";
  const dia = "01";
  return `${ano}-${mes}-${dia}`;
}

export function getOntemFormatado() {
  const hoje = new Date();
  const ano = hoje.getFullYear();
  const mes = String(hoje.getMonth() + 1).padStart(2, '0');
  const dia = String(hoje.getDate() - 1).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
}

export function getAnteontem() {
  const hoje = new Date();
  const ano = hoje.getFullYear();
  const mes = String(hoje.getMonth() + 1).padStart(2, '0');
  const dia = String(hoje.getDate() - 2).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
}

export function getHojeFormatado() {
  const hoje = new Date();
  const ano = hoje.getFullYear();
  const mes = String(hoje.getMonth() + 1).padStart(2, '0');
  const dia = String(hoje.getDate()).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
}

export function getDataSeteDiasAntesFormatado(dias) {
  const hoje = new Date();
  hoje.setDate(hoje.getDate() - dias);
  const ano = hoje.getFullYear();
  const mes = String(hoje.getMonth() + 1).padStart(2, '0');
  const dia = String(hoje.getDate()).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
}

export function getMesAtual() {
  const hoje = new Date();
  const ano = hoje.getFullYear();
  const mes = String(hoje.getMonth() + 1).padStart(2, '0');
  const dia = "01";
  return `${ano}-${mes}-${dia}`;
}

export function getMesPassado() {
  const hoje = new Date();
  const primeiroDiaMesPassado = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
  const ano = primeiroDiaMesPassado.getFullYear();
  const mes = String(primeiroDiaMesPassado.getMonth() + 1).padStart(2, '0');
  return `${ano}-${mes}-01`;
}

export function ultimoDiaMesPassado() {
  const hoje = new Date();
  const data = new Date(hoje.getFullYear(), hoje.getMonth(), 0);

  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const dia = String(data.getDate()).padStart(2, '0');

  return `${ano}-${mes}-${dia}`;
}

export const formatarDataComDiaSemana = (dataStr) => {
  const [ano, mes, dia] = dataStr.split("-");
  const data = new Date(ano, mes - 1, dia); // ✅ local, sem shift

  return data.toLocaleDateString("pt-BR", {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
  });
};